import { useMediaQuery } from "react-responsive";
import { ReactNode } from "react";

export const displaySize = {
  mobile: 375,
  tablet: 600,
  desktop: 1080,
};

const maxWidthQuery = (maxWidth: number) => `@media (max-width: ${maxWidth}px)`;
const minWidthQuery = (minWidth: number) => `@media (min-width: ${minWidth}px)`;

export const device = {
  mobile: maxWidthQuery(displaySize.tablet - 1),
  tablet: `@media (min-width: ${displaySize.tablet}px) and (max-width:${displaySize.desktop}px)`,
  desktop: minWidthQuery(displaySize.desktop),
};

interface Props {
  children: ReactNode;
}
export const Desktop = ({ children }: Props) => {
  const isDesktop = useMediaQuery({ minWidth: 1000 });
  return isDesktop ? children : null;
};

export const Tablet = ({ children }: Props) => {
  const isTablet = useMediaQuery({ minWidth: 600, maxWidth: 1000 });
  return isTablet ? children : null;
};

export const Mobile = ({ children }: Props) => {
  const isMobile = useMediaQuery({ maxWidth: 600 });
  return isMobile ? children : null;
};
